import React from 'react';
import PropTypes from 'prop-types';
import { Card as AntCard } from 'antd';
import { useTheme } from '../../contexts/ThemeContext';

const Card = ({ children, title, style, bodyStyle, ...props }) => {
  const { theme } = useTheme();

  const cardStyle = {
    backgroundColor: theme.cardBackground,
    border: `1px solid ${theme.border}`,
    color: theme.textSecondary,
    transition: 'all 0.3s ease',
    boxShadow: `0 4px 12px ${theme.shadowLight}`,
    borderRadius: 16,
    overflow: 'hidden',
    willChange: 'transform, box-shadow',
    
    ...style,
  };

  const headerStyle = {
    borderBottom: `1px solid ${theme.border}`,
    color: theme.textSecondary,
    backgroundColor: theme.cardBackground,
  };

  const antStyles = {
    header: headerStyle,
    ...(bodyStyle && { body: bodyStyle }),
  };

  return (
    <AntCard
      title={title}
      style={cardStyle}
      styles={antStyles}
      {...props}
    >
      {children}
    </AntCard>
  );
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.node,
  style: PropTypes.object,
};

export default Card;

